module.exports = __webpack_public_path__ + "img/logo.64cbc60a.svg";